module.exports = {
  src: __webpack_public_path__ + "logo-google-play-it-0a40036247335c9107c312b9755d006d.svg",
  width: 843,
  height: 250,
  bytes: 7731,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-google-play-it-0a40036247335c9107c312b9755d006d.svg";
};